export const IMAGES = {
  // Upscale editorial mat-based Pilates, diverse models, luxury at-home settings
  hero: "https://static.prod-images.emergentagent.com/jobs/6fdc8477-904c-4156-9dd8-34e464e0431c/images/b456e4de76a5ce595c910db0c08bb403aae74b5cc29f2a3449395c7debce60c4.jpeg",
  instructor: "https://static.prod-images.emergentagent.com/jobs/6fdc8477-904c-4156-9dd8-34e464e0431c/images/fde45c8051b0ae329c9e04600f34489c07ae4d046437aab1bf19d19258424af2.jpeg",
  session2: "https://static.prod-images.emergentagent.com/jobs/6fdc8477-904c-4156-9dd8-34e464e0431c/images/779cfa979254454ff37630544690f649973140cbc615928cc0ddbde5277ad548.jpeg",
  reformer: "https://static.prod-images.emergentagent.com/jobs/6fdc8477-904c-4156-9dd8-34e464e0431c/images/5f14ececa9277412fafbc1742d73b108d3f6d9cc1f171884e3ff8aa81382614d.jpeg",
  session1: "https://images.unsplash.com/photo-1599447472256-81e5e691e16b?auto=format&fit=crop&w=1000&q=80",
  interior: "https://images.unsplash.com/photo-1674600625236-ad76734fee0d?auto=format&fit=crop&w=1200&q=80",
  cadillac: "https://images.unsplash.com/photo-1651525764791-3ae6ce60094c?auto=format&fit=crop&w=1200&q=80",
};

export const MARQUEE = [
  "Private", "Bespoke", "At-Home", "Hampstead", "One-to-One",
  "Progressive", "Mindful", "Restorative", "Precise", "Yours Alone",
];

export const CHAPTERS = [
  {
    n: "01",
    title: "Mindful Alignment",
    body: "Every session begins with breath and posture. We rebuild movement from the ground up — spine long, ribs soft, intention clear.",
  },
  {
    n: "02",
    title: "Bespoke Attention",
    body: "No classes, no crowd. Just you, your body, and a programme shaped entirely around your goals, your history, and your home.",
  },
  {
    n: "03",
    title: "Movement as Art",
    body: "Strength should feel like grace. We chase control over intensity, so progress arrives quietly, consistently, and stays.",
  },
];

export const STEPS = [
  { n: "01", title: "Arrival & Assessment", body: "I arrive with everything needed. We talk through how your body feels today and set the intention for our hour." },
  { n: "02", title: "A Flow Made for You", body: "A sequence built live around your needs — mat and small equipment, adapted in real time to your range and energy." },
  { n: "03", title: "Precision Correction", body: "Hands-on, verbal, and visual cues refine every repetition. This is where the real change happens." },
  { n: "04", title: "Grounding & Close", body: "We finish with restorative work and breath, leaving you taller, calmer, and quietly stronger than when we began." },
];

export const TESTIMONIALS = [];

export const AREAS = ["Hampstead", "Belsize Park", "Highgate", "Primrose Hill", "St John's Wood", "Swiss Cottage"];
